<ion-header
  class="ion-no-border"
  [ngClass]="
    isTouch
      ? platform === platformEnum.tablet
        ? 'ion-header-modal-tablet'
        : 'ion-header-modal-mobile'
      : 'ion-header-modal-desktop'
  "
>
  <ion-toolbar>
    <ion-buttons *ngIf="isTouch === false" slot="end">
      <ion-button
        id="close-modal-btn"
        data-cy="close-confirm-delete-modal-button"
        (click)="dismiss()"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content
  data-cy="modal-prompt-area-text-delete"
  class="simple-action-modal_content"
  [ngClass]="
    isTouch
      ? platform === platformEnum.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
      : 'ion-content-modal-desktop'
  "
>
  <div class="content" [class.horizontal]="isTouch === false">
    <img
      src="assets/icon/alert-red.svg"
      class="warning-icon"
      *ngIf="isWarning"
    />
    <img
      src="assets/images/alert-yellow.svg"
      class="warning-icon"
      *ngIf="!isWarning"
    />

    <div class="delete-modal-text">
      <div class="header-text" data-cy="confirm-delete-item-label">
        {{ 'i18n.inventory.inventoryWorksheet.deleteItemsHeader' | translate }}
        <span
          class="count-text"
          data-cy="confirm-delete-slected-count"
          *ngIf="totalSelected.valueOf() === 1 && !hideCount"
        >
          {{ totalSelected }}

          {{ singular | translate }}</span
        >
        <span
          class="header-text"
          data-cy="confirm-delete-slected-count"
          *ngIf="totalSelected.valueOf() === 1 && hideCount"
        >
          {{ singular | translate }}</span
        >
        <span
          class="count-text"
          data-cy="confirm-delete-slected-count"
          *ngIf="totalSelected.valueOf() > 1"
        >
          {{ totalSelected }}

          {{ plural | translate }}</span
        >

        <span *ngIf="!hideCount" data-cy="confirm-delete-question-mark">?</span>
      </div>

      <p data-cy="confirm-delete-additonal-warning" *ngIf="additionalWarning">
        {{ additionalWarning | translate }}
      </p>
    </div>
  </div>
</ion-content>

<ion-footer
  class="ion-footer-modal"
  [class.ion-footer-modal-desktop]="isTouch === false"
>
  <ion-toolbar>
    <ion-buttons *ngIf="isWarning">
      <ion-button
        id="yes-modal-btn"
        data-cy="submit-warning-delete-modal-button"
        [ngClass]="
          platform !== platformEnum.mobile
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-mobile-modal-button'
        "
        (click)="submit()"
      >
        {{ 'i18n.common.continue' | translate }}
      </ion-button>
      <ion-button
        id="no-modal-btn"
        data-cy="no-confirm-warning-delete-modal-button"
        [ngClass]="
          platform !== platformEnum.mobile
            ? 'usf-fill-green-dsktp-tblt-modal-button'
            : 'usf-fill-green-mobile-modal-button'
        "
        (click)="dismiss()"
      >
        {{
          'i18n.inventory.inventoryWorksheet.deleteIventoryModalCancel'
            | translate
        }}
      </ion-button>
    </ion-buttons>
    <ion-buttons *ngIf="!isWarning">
      <ion-button
        id="no-modal-btn"
        data-cy="no-confirm-info-delete-modal-button"
        [ngClass]="
          platform !== platformEnum.mobile
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-mobile-modal-button'
        "
        (click)="dismiss()"
      >
        {{
          'i18n.inventory.inventoryWorksheet.deleteIventoryModalCancel'
            | translate
        }}
      </ion-button>
      <ion-button
        id="yes-modal-btn"
        data-cy="submit-info-delete-modal-button"
        [ngClass]="
          platform !== platformEnum.mobile
            ? 'usf-fill-green-dsktp-tblt-modal-button'
            : 'usf-fill-green-mobile-modal-button'
        "
        (click)="submit()"
      >
        {{ 'i18n.common.continue' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
